export var ProductType;
(function (ProductType) {
    ProductType["STUDY"] = "study";
    ProductType["SCHOLARSHIP"] = "scholarship";
    ProductType["PARTNER"] = "partner";
    ProductType["UNIVERSITY"] = "university";
})(ProductType || (ProductType = {}));
